import { Component, OnInit } from '@angular/core';

import { Course } from 'lms-api';
import { Observable } from 'rxjs';
import { StripHtml } from 'lms-api';
import { TitleWrapperService } from '../_services/title-wrapper.service';
import { UserCourseDataService } from 'lms-api';
import { UserDetail } from 'lms-api';

@Component({
  selector: 'app-transcript',
  templateUrl: './transcript.component.html',
  styleUrls: ['./transcript.component.scss']
})
export class TranscriptComponent implements OnInit {
  public courses$: Observable<Course[]> = this.ucdService.Courses$;
  public userDetails$: Observable<UserDetail> = this.ucdService.User;
  public sortField: string;
  
  public certificateBaseUrl;

  constructor(private ucdService: UserCourseDataService, private titleService: TitleWrapperService) {
    this.sortField = "title";
    this.certificateBaseUrl = this.ucdService.GetCertificateURL();
  }

  ngOnInit() {
    this.titleService.SetTitle('My CE Transcript');
  }

  public sortBy(field: string) {
    this.sortField = field;
  }
}
